import {combineReducers, Reducer} from "redux";

import {reduceRequestState, RequestState} from "../../app/utils/request_response_utils/factories/reduce_request_state";
import {reduceResponse} from "../../app/utils/request_response_utils/factories/reduce_response";
import {fetchSellerOffersTypes, ISellerOffersResult} from "../actions/fetch_seller_offers_at_route";

export interface ISellerStore {
    data: ISellerOffersResult | null;
    requestState: RequestState;
}

const sellerReducerObj: Record<keyof ISellerStore, Reducer<any, any>> = {
    data: reduceResponse(fetchSellerOffersTypes),
    requestState: reduceRequestState(fetchSellerOffersTypes)
};

export const sellerReducer = combineReducers(sellerReducerObj);
